<template>
    <div>
       <el-form ref="form" :model="form" label-width="100px">
          <el-form-item label="培训名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="培训简介">
            <el-input v-model="form.desc"></el-input>
          </el-form-item>
          <el-form-item label="培训地址">
            <el-input v-model="form.address"></el-input>
          </el-form-item>
          <el-form-item label="培训时间">
              <el-date-picker
              v-model="form.timerange"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"	
              >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="人数限制">
            <el-input v-model="form.limitnums"></el-input>
          </el-form-item>
          <el-form-item label="级别限制">
              <el-select
                v-model="form.allowmembers"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="请选择允许的级别">
                <el-option
                  v-for="(item,index) in levellist"
                  :key="index"
                  :label="item.name"
                  :value="item.level">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="报名费用">
            <el-input v-model="form.fee"></el-input>
          </el-form-item>
          <el-form-item label="地址必填">
                <el-select v-model="form.isaddress" placeholder="请选择">
                  <el-option label="否" :value="0"></el-option>
                  <el-option label="是" :value="1"></el-option>
                </el-select>
          </el-form-item>
          <el-form-item label="特殊处理">
            <el-select v-model="form.acttype" placeholder="请选择">
              <el-option label="否" :value="0"></el-option>
              <el-option label="上阶加100积分" :value="1"></el-option>
              <el-option label="上阶加32积分" :value="2"></el-option>
            </el-select>
         </el-form-item>
          <el-form-item label="封面图">
            <el-upload
              :action="uploadImgUrl"
              name='image'
              :data="{extra:'headimg',type:'pximg'}"
              list-type="picture-card"
              :limit='1'
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-success='handleUploadOK'
              :on-exceed='handleExceed'
              :file-list="filelist['headimg']"	
              >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
        </el-form-item>
          <el-form-item label="内容">
            <vue-ueditor-wrap v-model="form.content" :config="uEditConfig"></vue-ueditor-wrap>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSave">立即保存</el-button>
            <el-button @click='goBack'>取消</el-button>
          </el-form-item>
        </el-form>
    </div>  
</template>
<script>
  import VueUeditorWrap from 'vue-ueditor-wrap' 
  export default {
    components: {
          VueUeditorWrap
    },
    data() {
      const uEditorUrl=process.env.VUE_APP_UEDITOR_SERVERURL+'?token='+this.$store.state.user.token
      return {
        form: {
          id:'',
          name: '',
          desc: '',
          content:'',
          address:'',
          headimg:[],
          limitnums:'',
          timerange:[],
          allowmembers:'',
          fee:'',
          isaddress:'',
          acttype:''
        },
        uploadImgUrl:process.env.VUE_APP_API+"/upload/uploadImg",
        dialogImageUrl: '',
        dialogVisible: false,
        processing:false,
        filelist:[],

        typelist:[],
        uEditConfig: {
                  initialFrameHeight: 240,
                  initialFrameWidth: '100%',
                  serverUrl: uEditorUrl,
                  UEDITOR_HOME_URL: './plugins/UEditor/'
        },
        levellist:[]
      }
    },
    created(){
          this.form.id=this.$route.query.trainid==undefined?0:this.$route.query.trainid
          this.initTrain(this.form.id)
    },
    methods: {
      onSave() {
          if(this.processing){
             this.$message.error("请等待处理完成");return false
          }
          if(this.form.name==''){
            this.$message.error("培训名称不能为空");return false
          }
          if(this.form.desc==''){
            this.$message.error("培训介绍不能为空");return false
          }
          if(this.form.address==''){
            this.$message.error("培训地址不能为空");return false
          }
          if(this.form.address==''){
            this.$message.error("培训地址不能为空");return false
          }
          if(this.form.timerange.length<1){
            this.$message.error("请选择培训起止日期");return false
          }
          if(this.form.allowmembers==''){
            this.$message.error("级别限制不能为空");return false
          }
          if(this.form.limitnums==''){
            this.$message.error("人数限制不能为空");return false
          }
          if(this.form.fee=="" || isNaN(this.form.fee) || this.form.fee<0){
            this.$message.error("请输入报名费用");return false
          }
          
          if(this.form.isaddress===''){
            this.$message.error("请选择地址是否必填");return false
          }
          if(this.form.acttype===''){
            this.$message.error("请选择是否需要特殊处理");return false
          }
          if(this.form.headimg.length<1){
            this.$message.error("请上传封面图");return false
          }
          if(this.form.content==''){
            this.$message.error("内容不能为空");return false
          }
          
          if(this.form.headimg!=null && this.form.headimg.length>=1){
            this.form.headimg=this.form.headimg[0]
          }

          this.processing=true
          this.$post("/school/saveTrain",{traininfo:this.form}).then((data)=>{
               if(data.result.success){
                   this.$message({message:data.result.info,type:'success'})
                   setTimeout(()=>{this.$router.push('/trainlist')},500)
               }else{
                   this.$message.error(data.result.info)
               }
               this.processing=false
          })
      },
      initTrain(id){
          this.$post("/school/initTrain",{id:id}).then((data)=>{
              if(this.form.id>0){
                 this.form=data.result.info.traininfo
              }
              this.filelist=data.result.info.filelist
              this.levellist=data.result.info.levellist
          })
      },
      goBack(){
          this.$go("/trainlist")
      },
      handleRemove(file, fileList) {
        let type=file.response.result.info.extra
        switch(type){
          case 'headimg':
                this.form.headimg=this.getSlides(fileList);break;
          case 'slides':
                this.form.slides=this.getSlides(fileList);break;  
          default:
                this.$message("图片类型错误");      
        }
      },
      handleUploadOK(response, file, fileList){
        let type=response.result.info.extra
        switch(type){
          case 'headimg':  
                this.form.headimg=this.getSlides(fileList);break;    
          case 'slides':
                this.form.slides=this.getSlides(fileList);break;
          default:
                this.$message("图片类型错误");      
        }
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      getSlides(fileList){
         return fileList.map((item)=>item.response.result.info.url)
      },
      handleExceed(){
         this.$message.error("超出最大上传数量");
      }
    }
  }
</script>

<style scoped lang="scss">
::v-deep .el-select{width:100%;}
::v-deep .el-select .el-input{width:100%;}
</style>
